import { Button } from '@insurancemenu/imenu-components-lib';
import StepHeader from 'components/common/headers/StepHeader';
import React from 'react';
import { ContentCardStyled, StepSubtitleStyled } from './styles';

interface Props {
  isLoading: boolean;
  onSubmit: () => void;
}

const UncompleteStepSection: React.FC<Props> = ({ isLoading, onSubmit }) => {
  return (
    <ContentCardStyled loading={isLoading} minHeight="25rem">
      <StepHeader
        stepTitle="Need to Make Changes?"
        stepSubtitle={
          <StepSubtitleStyled>
            This step is already completed, but you can reopen it to make updates. Any steps that follow will be reset
            to keep everything in sync.
          </StepSubtitleStyled>
        }
      />
      <Button size="large" color="primary" onClick={onSubmit}>
        Make Changes
      </Button>
    </ContentCardStyled>
  );
};

export default UncompleteStepSection;
